"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardSection = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var CardSection = function (_a) {
    var blue = _a.blue, className = _a.className, color = _a.color, dark = _a.dark, green = _a.green, light = _a.light, lightblue = _a.lightblue, purple = _a.purple, red = _a.red, props = __rest(_a, ["blue", "className", "color", "dark", "green", "light", "lightblue", "purple", "red"]);
    var CardSectionClasses = classnames_1.default('CardSection', className, {
        'CardSection--blue': blue || color === 'blue',
        'CardSection--dark': dark || color === 'dark',
        'CardSection--green': green || color === 'green',
        'CardSection--light': light || color === 'light',
        'CardSection--purple': purple || color === 'purple',
        'CardSection--red': red || color === 'red',
        'CardSection--lightblue': lightblue || color === 'lightblue',
    });
    return react_1.default.createElement("div", __assign({ className: CardSectionClasses }, props));
};
exports.CardSection = CardSection;
exports.CardSection.displayName = 'CardSection';
//# sourceMappingURL=CardSection.js.map